import React, { useEffect } from 'react';
import { populateFootnoteSection } from 'root/core/footnoteSection';

type Footnote = {
    text: string;
    add_footnote: boolean;
    footnote: string;
};

type ModuleProps = {
    moduleClassName?: string;
    title?: string;
    titleSize?: 'h2' | 'h3' | 'h4';
    titleFootnote?: Footnote;
    titleClassName?: string;
    subtitle?: string;
    subtitleFootnote?: Footnote;
    backgroundColor?: 'black' | 'white' | 'grey';
    removeContainer?: boolean;
    moduleSpacing?: string;
    children: React.ReactNode;
};
function Module({
    moduleClassName,
    title,
    titleSize,
    titleFootnote,
    titleClassName,
    subtitle,
    subtitleFootnote,
    backgroundColor,
    removeContainer,
    moduleSpacing,
    children,
}: ModuleProps) {
    const { textColorClass, backgroundColorClass } = (() => {
        switch (backgroundColor) {
            case 'black':
                return {
                    textColorClass: 'gb-text-color--lightest',
                    backgroundColorClass: 'gb-background-color--darkest',
                };
            case 'grey':
                return {
                    textColorClass: 'gb-text-color--darkest',
                    backgroundColorClass: 'gb-background-color--light',
                };
            case 'white':
            default:
                return {
                    textColorClass: 'gb-text-color--darkest',
                    backgroundColorClass: 'gb-background-color--lightest',
                };
        }
    })();

    const titleSizeClass = titleSize ? `gb-${titleSize}` : '';
    const addFootnote = (originalString: string, footnote?: Footnote) => {
        return footnote?.add_footnote && footnote?.footnote ? (
            <span data-footnote={footnote.footnote}>{originalString}</span>
        ) : (
            originalString
        );
    };

    useEffect(() => {
        populateFootnoteSection();
    }, [title, subtitle, titleFootnote, subtitleFootnote]);

    return (
        <>
            <section
                className={`
                    ${moduleClassName}
                    ${backgroundColorClass}
                    ${moduleSpacing ?? 'gb-section-spacing'}
                `}
            >
                <header className="module-header">
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12">
                                {title && (
                                    <h2
                                        className={`text-center ${textColorClass} ${titleSizeClass} ${titleClassName}`}
                                    >
                                        {addFootnote(title, titleFootnote)}
                                    </h2>
                                )}
                                {subtitle && (
                                    <p className={`text-center ${textColorClass}`}>
                                        {addFootnote(subtitle, subtitleFootnote)}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </header>
                <div className={removeContainer ? '' : 'container'}>{children}</div>
            </section>
        </>
    );
}
export default Module;
